import { render, staticRenderFns } from "./xw.vue?vue&type=template&id=5d51fc15&scoped=true"
import script from "./xw.vue?vue&type=script&lang=js"
export * from "./xw.vue?vue&type=script&lang=js"
import style0 from "./xw.vue?vue&type=style&index=0&id=5d51fc15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d51fc15",
  null
  
)

export default component.exports